/**
 * Constants for the User Activity Dashboard.
 * Centralises option lists, table column definitions, and copy strings
 * so they aren't duplicated/inlined across the page component.
 */

/**
 * Type definition for time range options
 */
export interface TimeRangeOption {
  readonly value: number;
  readonly label: string;
}

/** Time-range dropdown options — value is passed as the `hours` query param. */
export const HOURS_OPTIONS: ReadonlyArray<TimeRangeOption> = [
  { value: 24, label: 'Last 24 hours' },
  { value: 168, label: 'Last 7 days' },
  { value: 720, label: 'Last 30 days' },
] as const;

/** Default lookback window, matches the Lambda's own default. */
export const DEFAULT_HOURS: number = 168 as const;

/** Page title for the User Activity Dashboard */
export const PAGE_TITLE: string = 'User Activity Dashboard' as const;

/**
 * Column definitions for widgets whose raw shape is `{ labels[], values[] }`
 * (bar/line/horizontal-bar) but are rendered here as tables instead.
 */
export const DAILY_ACTIVE_USERS_COLUMNS: readonly ['day', 'unique_users'] = ['day', 'unique_users'] as const;
export const TOP_USERS_COLUMNS: readonly ['user_email', 'api_calls'] = ['user_email', 'api_calls'] as const;

/** Warning message displayed when query results are incomplete */
export const PARTIAL_RESULTS_WARNING: string =
  'Some queries did not finish in time — results may be incomplete. Try refreshing.' as const;
